import type { ContextSnapshot } from '@/types/contextObservability'

function tryParseJson(value: string | null | undefined): unknown {
  if (!value) return value ?? null
  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}

export function extractLlmPayload(snapshot: ContextSnapshot) {
  return {
    model: snapshot.modelName,
    systemPrompt: snapshot.systemPromptContent,
    messages: snapshot.messages
      .filter(m => m.included)
      .map(m => ({
        role: m.role,
        content: m.text,
        ...(m.toolName && { toolName: m.toolName }),
      })),
    tools: snapshot.toolDefinitions.map(t => t.name),
    toolCalls: snapshot.toolCalls.map(tc => ({
      name: tc.toolName,
      input: tryParseJson(tc.inputSummary),
      outputSizeBytes: tc.outputSizeBytes,
      output: tryParseJson(tc.outputPreview),
      durationMs: tc.durationMs,
    })),
    projectContext: snapshot.projectContext,
    sessionContext: snapshot.sessionContextItems.map(i => ({
      kind: i.kind,
      id: i.id,
      title: i.title,
    })),
    tokenUsage: {
      contextWindow: snapshot.contextWindowSize,
      prompt: snapshot.totalPromptTokens,
      completion: snapshot.totalCompletionTokens,
      cacheRead: snapshot.cacheReadTokens,
      cacheWrite: snapshot.cacheWriteTokens,
      cacheHitRatio: snapshot.cacheHitRatio,
    },
  }
}
